<div class="sidebar">
  <div class="sidebar-header">
    <div class="company-name">assemblerai</div>
    <button mat-icon-button class="new-chat-button" (click)="onNewChat()" title="New Chat" data-testid="sidebar-new-chat">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <div class="sidebar-content">
    @if (loadingTasks) {
      <div class="sidebar-state">Loading tasks...</div>
    } @else if (tasksError) {
      <div class="sidebar-state error">
        <span>{{ tasksError }}</span>
        <button mat-button (click)="loadTasks()">Retry</button>
      </div>
    } @else {
      @for (status of statusOrder; track status) {
        @if (tasksByStatus[status].length) {
          <div class="sidebar-group">
            <div class="sidebar-group-label">{{ formatStatus(status) }} ({{ tasksByStatus[status].length }})</div>
            @for (task of tasksByStatus[status]; track task.id) {
              <button
                class="task-card"
                [class.active]="activeConversationId === task.id"
                (click)="selectTask(task.id)"
                type="button">
                <div class="task-card-name">{{ task.name || 'Unknown Client' }}</div>
                <div class="task-card-email">{{ task.id || 'Unknown ID' }}</div>
              </button>
            }
          </div>
        }
      }
      @if (!hasAnyTasks) {
        <div class="sidebar-state">No inquiries awaiting user input</div>
      }
    }
  </div>

  <div class="sidebar-footer">
    @if (user(); as userData) {
      <div class="user-chip" title="Signed in" data-testid="sidebar-user-chip">
        @if (userData.picture) {
          <img class="user-avatar" [src]="userData.picture" [alt]="userData.name || 'User'" />
        } @else {
          <div class="user-avatar fallback" aria-hidden="true">
            <mat-icon>person</mat-icon>
          </div>
        }
        <div class="user-meta">
          <div class="user-name">{{ userData.name || 'Authenticated' }}</div>
          <div class="user-email">{{ userData.email }}</div>
        </div>
      </div>
    }
  </div>
</div>
